// @flow
import { ThemeProvider } from '@material-ui/core/styles';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { resources } from './i18n/es';
import theme from './theme';
import App from './lib/App';

require('dotenv').config();

App.initI18n(resources);

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme} >
      <App provider="ecuafirma"/>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

serviceWorker.unregister();
